/* wf-badge-fit.js – 2026-11-04 (Felicia, UTKAST 107). Etiketterna på produktkorten ska alltid ligga på en rad
   (vänster etikett + höger pill). Mäter varje kort: börjar på maxstorleken och krymper textstorleken (--wfb-fit) tills raden får plats med luft emellan. */
(function () {
  var SEL = '.wf-pc, .wf-po__card, .wf-eb__card';
  var MIN = 5.5;
  function parts(c) {
    var all = c.querySelectorAll('.wf-pc__badge, .wf-pc__pill, .wf-po__badge, .wf-po__pill, .wf-eb__badge, .wf-eb__pill');
    var v = [];
    for (var i = 0; i < all.length; i++) if (all[i].offsetWidth && getComputedStyle(all[i]).display !== 'none') v.push(all[i]);
    return v;
  }
  function bad(c, v) {
    var box = (c.querySelector('.wf-pc__card') || c).getBoundingClientRect();
    var r = v.map(function (e) { return e.getBoundingClientRect(); });
    var minL = Infinity, maxR = -Infinity;
    for (var i = 0; i < r.length; i++) {
      minL = Math.min(minL, r[i].left); maxR = Math.max(maxR, r[i].right);
      for (var j = i + 1; j < r.length; j++) {
        var a = r[i], b = r[j];
        if (a.top < b.bottom && b.top < a.bottom && a.left < b.right + 4 && b.left < a.right + 4) return true;
        if (Math.abs((a.top + a.bottom) - (b.top + b.bottom)) > 3) return true; /* inte på samma rad */
      }
    }
    var gl = minL - box.left, gr = box.right - maxR;
    if (gl < 2 || gr < 2) return true;
    if (r.length > 1 && gr < gl - 1) return true; /* högra pillen får inte gå närmare kanten än den vänstra */
    return false;
  }
  function fit(c) {
    var v = parts(c);
    if (!v.length) { c.style.removeProperty('--wfb-fit'); return; }
    var fs = parseFloat(getComputedStyle(c).getPropertyValue('--wfb-max')) || 12;
    c.style.setProperty('--wfb-fit', fs + 'px');
    while (bad(c, v) && fs > MIN) {
      fs -= 0.25;
      c.style.setProperty('--wfb-fit', fs + 'px');
    }
  }
  function run(root) {
    var cs = (root || document).querySelectorAll(SEL);
    for (var i = 0; i < cs.length; i++) fit(cs[i]);
  }
  var t;
  function later() { clearTimeout(t); t = setTimeout(function () { run(); }, 120); }
  function init() {
    run();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { run(); });
    window.addEventListener('resize', later);
    if (window.MutationObserver) new MutationObserver(function (m) {
      for (var i = 0; i < m.length; i++) if (m[i].addedNodes.length) { later(); return; }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* 2026-11-04 t161u: samma regel på produktsidan (.wf-pd__top) – en rad, krymp texten tills den får plats */
(function () {
  function fit(t) {
    var fs = 12; t.style.setProperty('--wfpd-fit', fs + 'px');
    while (t.scrollWidth > t.clientWidth + 1 && fs > 6.5) { fs -= 0.25; t.style.setProperty('--wfpd-fit', fs + 'px'); }
  }
  function run() { var a = document.querySelectorAll('.wf-pd__top'); for (var i = 0; i < a.length; i++) fit(a[i]); }
  var t; function later() { clearTimeout(t); t = setTimeout(run, 120); }
  function init() { run(); if (document.fonts && document.fonts.ready) document.fonts.ready.then(run); window.addEventListener('resize', later); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
